import { useEffect, useState } from 'react';
import { get, post, useAuth } from '../api';
import FindUser from '../components/FindUser/FindUser';
import { useTeaForm } from '../util/tea-form';
import Conversation from '../components/Conversation';

function CreateConversation() {
  const { value, handleChange } = useTeaForm();
  const auth = useAuth();

  const handleSubmit = () => {
    post('messages', { participantIds: [auth?.sub, value] }).catch(() => {});
  };

  return (
    <div>
      <FindUser value={value} onChange={handleChange} />
      <button className="button" onClick={handleSubmit}>
        Start
      </button>
    </div>
  );
}

export default function MessagesPage() {
  const [conversations, setConversations] = useState([]);
  const reload = async () =>
    get('messages')
      .then(setConversations)
      .catch(() => {});
  useEffect(() => {
    reload();
  }, []);

  return (
    <div>
      <CreateConversation />
      {conversations.map((conversation: any) => (
        <Conversation conversationId={conversation.id} />
      ))}
    </div>
  );
}
